export default function (txt) {
  if (!txt) return ''
  txt = txt.toLowerCase()
  const b = txt.split(' ')
  txt = ''
  b.forEach((item) => {
    if (item.length <= 1) txt += `${item} `
    else txt += `${item[0].toUpperCase() + item.slice(1)} `
  })
  return txt
}
